import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../Context/UserContext';
import ManageHero from './ManageHero';
import ManageBrands from './ManageBrands';
import ManageHeader from './ManageHeader';
import ManageFooter from './ManageFooter';
import ManagePages from './ManagePages';
import ManageHomeContent from './ManageHomeContent';
import './Admin.css';

export default function AppearanceAdmin() {
  const [activeTab, setActiveTab] = useState('hero');
  const { role, loading } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && role !== 'admin') {
      navigate('/admin/products');
    }
  }, [role, loading, navigate]);

  if (loading || role !== 'admin') return null;

  const renderContent = () => {
    switch (activeTab) {
      case 'hero': return <ManageHero />;
      case 'brands': return <ManageBrands />;
      case 'header': return <ManageHeader />;
      case 'home-content': return <ManageHomeContent />;
      case 'footer': return <ManageFooter />;
      case 'pages': return <ManagePages />;
      default: return <ManageHero />;
    }
  };

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h2>Appearance Settings</h2>
        <p>Customize the look and feel of your store</p>
      </div>

      <div className="appearance-tabs">
        <button 
          className={`tab-btn ${activeTab === 'hero' ? 'active' : ''}`}
          onClick={() => setActiveTab('hero')}
        >
          Hero Section
        </button>
        <button 
          className={`tab-btn ${activeTab === 'home-content' ? 'active' : ''}`}
          onClick={() => setActiveTab('home-content')}
        >
          Home Content
        </button>
        <button 
          className={`tab-btn ${activeTab === 'brands' ? 'active' : ''}`}
          onClick={() => setActiveTab('brands')}
        >
          Brands
        </button>
        <button 
          className={`tab-btn ${activeTab === 'header' ? 'active' : ''}`}
          onClick={() => setActiveTab('header')}
        >
          Header
        </button>
        <button 
          className={`tab-btn ${activeTab === 'footer' ? 'active' : ''}`}
          onClick={() => setActiveTab('footer')}
        >
          Footer
        </button>
        <button 
          className={`tab-btn ${activeTab === 'pages' ? 'active' : ''}`}
          onClick={() => setActiveTab('pages')}
        >
          Pages Content
        </button>
      </div>

      <div className="tab-content">
        {renderContent()}
      </div>
    </div>
  );
}
